import * as React from "react";
import * as Frontend from "kmmp/frontend";
import { useMemo, useState } from "react";
import { getSampleFrames, getSampleFramePreviewImageUrl, getSampleFrameImageUrl } from "client/image-urls";
import { useWhitelabel } from "client/hooks";
import { Repeater } from "shared/components";
import { PublicImage } from "client/components/public-image";

type Props = {
    type: "packages" | "frames" | "corners";
}

/**
 * Component for displaying the product images for a given Sample Frame product type.
 */
export function VisualSampleFramePreview(props: Props): JSX.Element {
    const whitelabel = useWhitelabel();

    const sampleImages = useMemo(() => {
        return getSampleFrames(whitelabel.companyName, props.type)
    }, [whitelabel.companyName, props.type]);

    const [selectedImageName, selectImageName] = useState(sampleImages[0].name);

    const selectedImageSrc = useMemo(() => {
        return getSampleFramePreviewImageUrl(selectedImageName, props.type);
    }, [selectedImageName, props.type]);

    return (
        <div className="pure-g justify-space-between">
            <div className="pure-u-sm-visible pure-u-sm-9-24">
                <div className="thumbnails">
                    <Repeater source={sampleImages}>
                        {(image) => (
                            <SampleFrameImage
                                key={props.type + "-" + image.name}
                                image={image}
                                onClick={selectImageName}
                            />
                        )}
                    </Repeater>
                </div>
            </div>
            <div className="pure-u-sm-visible pure-u-sum-1-24" />
            <div className="pure-u-1 pure-u-sm-14-24">
                <PublicImage className="img-responsive"
                    style={{ objectFit: "contain" }}
                    src={selectedImageSrc}
                    alt={"Sample Portraits preview"}
                />
            </div>
        </div>
    );
}

type SampleFrameImageProps = {
    image: Frontend.SampleFrameImage
    onClick: (frame: Frontend.SampleFrameName) => void
}

export function SampleFrameImage({image, onClick}: SampleFrameImageProps): React.ReactElement {
    const whitelabel = useWhitelabel();
    const url = useMemo(() => getSampleFrameImageUrl(whitelabel.companyName, image), [whitelabel.companyName, image]);

    const handleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        onClick(image.name);
    }

    return (
       <div className="pure-u-sm-12-24 pure-padded">
            <a href="#" onClick={handleClick}>
                <PublicImage style={{ paddingTop: "10px", paddingBottom: "10px" }}
                     src={url}
                     className="img-responsive"
                />
            </a>
        </div>
    );
}
